/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum GeneratableDocumentWorkflowTemplateType {
    GDPR_NOTICE = 'GDPR_NOTICE',
    ANNUAL_STATEMENT = 'ANNUAL_STATEMENT',
    FORM_S431 = 'FORM_S431',
}
